import LoadingSpinner from '$tablet-app/src/app/components/LoadingSpinner';
import { PinGrid } from '$tablet-app/src/app/components/PinGrid';
import Row from '$tablet-app/src/app/components/Row';
import { Button } from '@akin-home/buttons/native';
import { PasswordInput, TextInput } from '@akin-home/forms/native';
import { StyleSheet } from 'react-native';
import styled from 'styled-components/native';
import { LoginScreenPasswordMode } from '../login_screen_state';
import { PasswordModeButton } from './PasswordModeButton';

type Props = {
  username?: string;
  setUsername?(text: string): void;

  password?: string;
  setPassword?(text: string): void;

  password_mode?: LoginScreenPasswordMode;
  setPasswordMode?(password_mode: LoginScreenPasswordMode): void;

  onPressLogin?(): void;
  onPressForgotPassword?(): void;

  loading?: boolean;
};

export function LoginForm(props: Props) {
  const { loading, password, password_mode, setPassword } = props;

  function onPressPinNumber(number: string) {
    setPassword?.((password || '') + number);
  }

  function onPressClearPin() {
    setPassword?.('');
  }

  function onPressRemovePin() {
    setPassword?.((password || '').slice(0, -1));
  }

  return (
    <Container>
      <TextInput
        placeholder="Username"
        value={props.username}
        onChangeText={props.setUsername}
      />

      {password_mode === 'pin' ? (
        <PasswordInput
          style={styles.pinPasswordInput}
          focusable={false}
          editable={false}
          placeholder="PIN"
          value={password}
        />
      ) : (
        <PasswordInput
          textInputStyle={styles.passwordInputText}
          placeholder="Password"
          value={props.password}
          onChangeText={props.setPassword}
        />
      )}

      <Row justifyContent="flex-end">
        <Button
          onPress={props.onPressForgotPassword}
          variant="text"
          size="small"
        >
          Forgot password
        </Button>
      </Row>

      {password_mode === 'pin' ? (
        <PinContainer>
          <PinGrid
            onPressNumber={onPressPinNumber}
            onPressClear={onPressClearPin}
            onPressRemove={onPressRemovePin}
          />
        </PinContainer>
      ) : null}

      <PasswordModeButtons>
        <PasswordModeButton
          mode="password"
          icon="key"
          label="Password"
          selected={password_mode === 'password'}
          onPress={props.setPasswordMode}
        />
        <PasswordModeButton
          mode="pin"
          icon="grid"
          label="Pin"
          selected={password_mode === 'pin'}
          onPress={props.setPasswordMode}
        />
      </PasswordModeButtons>

      <LoginContainer>
        <LoginButton
          size="large"
          onPress={props.onPressLogin}
          disabled={loading}
        >
          {loading ? <LoadingSpinner color="white" size="large" /> : 'Login'}
        </LoginButton>
      </LoginContainer>
    </Container>
  );
}

const Container = styled.View`
  gap: 15px;
  max-width: 500px;
  width: 100%;
`;

const PasswordModeButtons = styled.View`
  flex-direction: row;
  gap: 15px;
  justify-content: center;
`;

const PinContainer = styled.View`
  align-items: center;
  gap: 10px;
`;

const LoginContainer = styled.View`
  align-items: center;
`;

const LoginButton = styled(Button)`
  width: 100%;
  max-width: 300px;
`;

const styles = StyleSheet.create({
  passwordInputText: {
    minWidth: 0,
  },
  pinPasswordInput: {
    width: '100%',
  },
});
